export class SchedulePeriod {
	constructor() {
	}
} 
